import Dashboard from './Dashboard';

export default {
  install(store) {
    if (!store.state.Dashboard) {
      store.registerModule(['Dashboard'], Dashboard);
    }
  },
  uninstall(store) {
    store.unregisterModule(['Dashboard']);
  },
};
